document.addEventListener("teeinblue-event-component-injected", function () {
  const insertAfterElement = document.querySelector(".tee-product-price");
  const productBlocks = document.querySelectorAll(".product-block");
  let elementToMove = null;
  let elementToMove2 = null;
  productBlocks.forEach((block) => {
    if (block.textContent.trim() == "Limited time deal") {
      elementToMove = block;
    }
  });
  productBlocks.forEach((block) => {
    if (
      block.textContent.includes(
        "Black Friday Starts Early: 40% OFF – Lowest Price of the Year!"
      )
    ) {
      console.log(block);
      elementToMove2 = block;
    }
  });
  if (elementToMove2 && insertAfterElement) {
    insertAfterElement.after(elementToMove2);
  }
  if (elementToMove && insertAfterElement) {
    insertAfterElement.after(elementToMove);
  }
});

document.addEventListener('teeinblue-event-component-injected', function() {
    const elementToMove3 = document.querySelector('.promo-bar-container');
    const insertAfterElement3 = document.querySelector('.tee-product-price');
    if (elementToMove3 && insertAfterElement3) {        
     insertAfterElement3.after(elementToMove3)
    } 

    const elementToMove4 = document.querySelector('.after-price-block');
    const insertAfterElement4 = document.querySelector('.tee-product-price');
    if (elementToMove4 && insertAfterElement4) {        
     insertAfterElement4.after(elementToMove4)
    } 
});

(function() {
    // Line-item key -> TeeInBlue preview URL ('' when the line has none).
    // Filled from /cart.js only when the drawer shows a line we have not seen,
    // so a SlideCart re-render can never trigger another fetch (that loop hit
    // /cart.js several times a second).
    let previewByKey = {};
    let cartFetchInFlight = false;

    function linkUploadedImages() {
        const propertyValues = document.querySelectorAll('#slidecarthq .properties-key-value-value');
        propertyValues.forEach(el => {
            if (el.querySelector('a')) return;
            const text = el.textContent.trim();
            if (text.includes('/customers/uploads/') && (text.startsWith('http://') || text.startsWith('https://'))) {
                el.innerHTML = `<a class="pplr_slide" href="${text}" target="_blank" rel="noopener noreferrer">Click To View Image</a>`;
            }
        });
    }

    // Applies cached previews; returns true if a drawer line is not cached yet.
    function applyPreviewImages() {
        let hasUnknownLine = false;
        document.querySelectorAll('#slidecarthq .item[data-line-item-key]').forEach(itemEl => {
            const key = itemEl.getAttribute('data-line-item-key');
            if (!Object.prototype.hasOwnProperty.call(previewByKey, key)) {
                hasUnknownLine = true;
                return;
            }
            const preview = previewByKey[key];
            const imgEl = itemEl.querySelector('img');
            if (preview && imgEl && imgEl.src !== preview) {
                imgEl.src = preview;
            }
        });
        return hasUnknownLine;
    }

    function refreshPreviewCache() {
        if (cartFetchInFlight) return;
        cartFetchInFlight = true;
        const drawerKeys = [...document.querySelectorAll('#slidecarthq .item[data-line-item-key]')]
            .map(itemEl => itemEl.getAttribute('data-line-item-key'));

        fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
                const next = {};
                // Mark every line the drawer showed as known, so a stale key cannot re-trigger a fetch.
                drawerKeys.forEach(key => { next[key] = ''; });
                cart.items.forEach(item => {
                    next[item.key] = (item.properties && item.properties._customization_image) || '';
                });
                previewByKey = next;
                applyPreviewImages();
            })
            .catch(err => console.error('SlideCart preview refresh failed:', err))
            .finally(() => { cartFetchInFlight = false; });
    }

    function handleSlideCartUpdates() {
        linkUploadedImages();
        if (applyPreviewImages()) {
            refreshPreviewCache();
        }
    }

    const checkSlideCartExist = setInterval(() => {
        const slideCartRoot = document.querySelector('#slidecarthq');
        if (slideCartRoot) {
            clearInterval(checkSlideCartExist);

            const observer = new MutationObserver((mutations) => {
                handleSlideCartUpdates();
            });

            observer.observe(slideCartRoot, {
                childList: true,
                subtree: true,
                characterData: true
            });

            handleSlideCartUpdates();
        }
    }, 500);

    document.addEventListener('click', (e) => {
        if (e.target.closest('#slidecarthq') || e.target.closest('[class*="slidecart"]')) {
            setTimeout(handleSlideCartUpdates, 300);
        }
    });
})();

/* =========================================================
   ADD TO CART FEEDBACK (theme buttons only)
   UploadKit products and plain products never show a loading
   state, because the add request bypasses the theme. This shows
   the same grey + spinner look as TeeInBlue's button while a
   real /cart/add request is running.
   Visual only: it never disables, blocks, or intercepts the
   button. After a successful add it stays until the cart drawer
   starts opening (max 2.5s more), so the button never looks idle
   while the drawer loads. It always clears: request failed, no
   request started within 4s, invalid form, or a 20s hard cap.
   Skipped: TeeInBlue (#teeAtcButton), Product Personalizer
   (.p_a_t_c, which has its own loading state) and UploadKit's
   validation button (.uploadkit-cloned-atc-button).
   Globo Product Options buttons: cleared as soon as Globo marks a
   field with an error; otherwise kept up to 12s, because Globo
   takes several seconds before it sends the add.
   ========================================================= */
(function () {
    if (window.__mpAtcFeedback) return;
    window.__mpAtcFeedback = true;

    var BUSY_CLASS = 'mp-atc-busy';
    var BUTTON_SELECTOR = '.product-single__form button.add-to-cart';
    var NO_REQUEST_TIMEOUT = 4000;
    var DRAWER_WAIT = 2500;
    var GPO_BUTTONS = '.gpo-clone-atc-button, .gpo-clone-stickyAtc-button';
    var GPO_REQUEST_TIMEOUT = 12000;
    var GPO_ERROR_WATCH = 1500;
    var HARD_CAP = 20000;
    var active = null;

    // Class is doubled so the busy look outranks the yellow :hover/:active rules in custom.css.
    var style = document.createElement('style');
    style.textContent =
        '.product-single__form button.btn.btn--full.add-to-cart.' + BUSY_CLASS + '.' + BUSY_CLASS + ':not(#teeAtcButton){' +
            'background:#BBC4D2 !important;background-color:#BBC4D2 !important;' +
            'border-color:#BBC4D2 !important;box-shadow:none !important;cursor:progress;transform:none;}' +
        '.product-single__form button.btn.btn--full.add-to-cart.' + BUSY_CLASS + '.' + BUSY_CLASS + ':not(#teeAtcButton) > span{' +
            'display:none !important;}' +
        '.product-single__form button.btn.btn--full.add-to-cart.' + BUSY_CLASS + '.' + BUSY_CLASS + ':not(#teeAtcButton)::after{' +
            'content:"" !important;display:inline-block !important;position:static !important;' +
            'width:20px !important;height:20px !important;margin:0 !important;' +
            'border:3px solid #182633 !important;border-top-color:transparent !important;' +
            'border-radius:50% !important;background:none !important;' +
            'animation:mp-atc-spin .8s linear infinite !important;}' +
        '@keyframes mp-atc-spin{to{transform:rotate(360deg)}}' +
        '@media (prefers-reduced-motion:reduce){' +
            '.product-single__form button.btn.btn--full.add-to-cart.' + BUSY_CLASS + '.' + BUSY_CLASS + ':not(#teeAtcButton)::after{' +
            'animation-duration:2s !important;}}';
    (document.head || document.documentElement).appendChild(style);

    function isAddToCartUrl(url) {
        return /\/cart\/add(\.js|\.json)?(\?|#|$)/.test(String(url || ''));
    }

    // SlideCart's panel transform; changes when the drawer starts to open.
    function drawerTransform() {
        var panel = document.querySelector('#slidecarthq .slidecarthq');
        return panel ? getComputedStyle(panel).transform : null;
    }

    function isEligible(button) {
        return !!button &&
            button.id !== 'teeAtcButton' &&
            !button.classList.contains('p_a_t_c') &&
            !button.classList.contains('uploadkit-cloned-atc-button');
    }

    function clear() {
        if (!active) return;
        active.button.classList.remove(BUSY_CLASS);
        active.button.removeAttribute('aria-busy');
        clearTimeout(active.noRequestTimer);
        clearTimeout(active.capTimer);
        active = null;
    }

    function start(button) {
        clear();
        var state = { button: button, pending: 0, sawRequest: false, anyFailed: false, drawerAtStart: drawerTransform(), isGpo: button.matches(GPO_BUTTONS) };
        active = state;
        button.classList.add(BUSY_CLASS);
        button.setAttribute('aria-busy', 'true');
        state.noRequestTimer = setTimeout(function () {
            if (active === state && !state.sawRequest) clear();
        }, NO_REQUEST_TIMEOUT);
        state.capTimer = setTimeout(function () {
            if (active === state) clear();
        }, HARD_CAP);
        if (state.isGpo) watchGpoErrors(state);
    }

    // Globo shows missing fields by adding .has-error to their groups.
    function gpoHasVisibleErrors() {
        return [].some.call(document.querySelectorAll('.gpo-form__group.has-error'), function (el) {
            return el.offsetParent !== null;
        });
    }

    function watchGpoErrors(state) {
        var waited = 0;
        function check() {
            if (active !== state || state.sawRequest) return;
            if (gpoHasVisibleErrors()) {
                clear();
                return;
            }
            if (waited >= GPO_ERROR_WATCH) {
                // No errors: Globo is working on the add, which can take several seconds.
                clearTimeout(state.noRequestTimer);
                state.noRequestTimer = setTimeout(function () {
                    if (active === state && !state.sawRequest) clear();
                }, GPO_REQUEST_TIMEOUT);
                return;
            }
            waited += 100;
            setTimeout(check, 100);
        }
        // First look after Globo has had a moment to run its own check.
        setTimeout(check, 100);
    }

    // After a successful add, clear once the drawer starts moving (or after DRAWER_WAIT).
    function clearWhenDrawerOpens(state) {
        var start = state.drawerAtStart;
        if (start === null || start === 'none') {
            clear();
            return;
        }
        var waited = 0;
        (function check() {
            if (active !== state) return;
            if (drawerTransform() !== start || waited >= DRAWER_WAIT) {
                clear();
                return;
            }
            waited += 50;
            setTimeout(check, 50);
        })();
    }

    // Returns a callback(ok) for when the request settles, or null if nothing is showing.
    function trackRequest() {
        if (!active) return null;
        var state = active;
        state.sawRequest = true;
        state.pending += 1;
        var settled = false;
        return function (ok) {
            if (settled) return;
            settled = true;
            state.pending -= 1;
            if (!ok) state.anyFailed = true;
            if (active !== state || state.pending > 0) return;
            if (state.anyFailed) {
                clear();
            } else {
                clearWhenDrawerOpens(state);
            }
        };
    }

    // Passive listener: never calls preventDefault or stopPropagation.
    document.addEventListener('click', function (event) {
        var button = event.target && event.target.closest ? event.target.closest(BUTTON_SELECTOR) : null;
        if (!isEligible(button) || button.disabled) return;
        var form = button.form || button.closest('form');
        // Globo keeps a hidden, always-empty required #validator in the form, so the
        // browser check is skipped for its button; watchGpoErrors handles Globo instead.
        if (form && !button.matches(GPO_BUTTONS) && form.matches(':invalid')) return;
        start(button);
    }, true);

    // Browser validation blocked the submit: clear right away.
    document.addEventListener('invalid', function (event) {
        if (!active || active.isGpo) return;
        var form = active.button.form || active.button.closest('form');
        if (!form || form.contains(event.target)) clear();
    }, true);

    var originalFetch = window.fetch;
    if (typeof originalFetch === 'function') {
        window.fetch = function (input) {
            var url = typeof input === 'string' ? input : (input && input.url) || '';
            var result = originalFetch.apply(this, arguments);
            if (isAddToCartUrl(url)) {
                var done = trackRequest();
                if (done && result && typeof result.then === 'function') {
                    result.then(function (response) { done(!!response && response.ok); }, function () { done(false); });
                }
            }
            return result;
        };
    }

    var xhrProto = XMLHttpRequest.prototype;
    var originalOpen = xhrProto.open;
    var originalSend = xhrProto.send;
    xhrProto.open = function (method, url) {
        this.__mpIsAddToCart = isAddToCartUrl(url);
        return originalOpen.apply(this, arguments);
    };
    xhrProto.send = function () {
        if (this.__mpIsAddToCart) {
            var done = trackRequest();
            if (done) {
                var xhr = this;
                xhr.addEventListener('loadend', function () { done(xhr.status >= 200 && xhr.status < 300); });
            }
        }
        return originalSend.apply(this, arguments);
    };
})();

/* =========================================================
   GLOBO PRODUCT OPTIONS GUARD
   SlideCart adds any clicked submit button inside a cart form
   straight away. On Globo products (pajamas) that meant a click
   with empty required fields still added a blank item, while
   Globo was showing "This field is required". Globo already
   validates and adds the item itself when the fields are valid,
   so clicks on Globo's button are kept from reaching SlideCart's
   page-level listener. Globo's own handlers still run.
   ========================================================= */
(function () {
    var GPO_BUTTONS = '.gpo-clone-atc-button, .gpo-clone-stickyAtc-button';

    function guardForm(form) {
        if (form.__mpGpoGuard) return;
        form.__mpGpoGuard = true;
        form.addEventListener('click', function (event) {
            if (event.target && event.target.closest && event.target.closest(GPO_BUTTONS)) {
                event.stopPropagation();
            }
        });
    }

    function guardAll() {
        document.querySelectorAll('form[action$="/cart/add"]').forEach(guardForm);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', guardAll);
    } else {
        guardAll();
    }
    window.addEventListener('load', guardAll);
})();
